import {Box, Typography, TypographyProps} from '@mui/material';
import {useTranslation} from 'next-i18next';
import {Tag} from '../../types/models/Tag';
import {getLocaleLabels} from '../../utils/lang';

type TagProps = {
    tag: Tag;
    sx: TypographyProps['sx'];
};

export default function TagElement(props: TagProps) {
    const {i18n} = useTranslation('common');
    const locale = getLocaleLabels(props.tag.labels, i18n.language);
    return (
        <Box alignSelf="center">
            <Typography
                sx={{
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    maxWidth: '150px',
                    ...props.sx,
                }}
            >
                {locale.label}
            </Typography>
        </Box>
    );
}
